import { completeName, i18n } from '../../utils';

export const normalizeProfessionalsList = (payload: any) => {
  const data = payload?.item?.items;
  return data ? data.map((item: any) => ({
    ...item,
    name: completeName(item.firstName, item.middleName, item.lastName),
    access: i18n(item.access),
    // El back manda ACTIVE/SUSPENDED; un usuario sin restricción viene como ACTIVE, nunca vacío.
    accessStatusLabel: i18n(
      item.accessStatus === 'SUSPENDED' ? 'professional.access.suspended' : 'professional.access.active',
    ),
  })) : [];
};
